/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import CustomerShoppingCartBookListBookCartDto from './CustomerShoppingCartBookListBookCartDto';
import CustomerShoppingCartBookListBookDto from './CustomerShoppingCartBookListBookDto';

/**
 * The CustomerShoppingCartBookListDto model module.
 * @module model/CustomerShoppingCartBookListDto
 * @version v1.0.0
 */
class CustomerShoppingCartBookListDto {
    /**
     * Constructs a new <code>CustomerShoppingCartBookListDto</code>.
     * @alias module:model/CustomerShoppingCartBookListDto
     */
    constructor() { 
        
        CustomerShoppingCartBookListDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>CustomerShoppingCartBookListDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/CustomerShoppingCartBookListDto} obj Optional instance to populate.
     * @return {module:model/CustomerShoppingCartBookListDto} The populated <code>CustomerShoppingCartBookListDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new CustomerShoppingCartBookListDto();

            if (data.hasOwnProperty('bookCount')) {
                obj['bookCount'] = ApiClient.convertToType(data['bookCount'], 'Number');
            }
            if (data.hasOwnProperty('bookListId')) {
                obj['bookListId'] = ApiClient.convertToType(data['bookListId'], 'Number');
            }
            if (data.hasOwnProperty('books')) {
                obj['books'] = ApiClient.convertToType(data['books'], [CustomerShoppingCartBookListBookDto]);
            }
            if (data.hasOwnProperty('cart')) {
                obj['cart'] = ApiClient.convertToType(data['cart'], [CustomerShoppingCartBookListBookCartDto]);
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('selectedBookCount')) {
                obj['selectedBookCount'] = ApiClient.convertToType(data['selectedBookCount'], 'Number');
            }
            if (data.hasOwnProperty('selectedBookQuantityCount')) {
                obj['selectedBookQuantityCount'] = ApiClient.convertToType(data['selectedBookQuantityCount'], 'Number');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Number} bookCount
 */
CustomerShoppingCartBookListDto.prototype['bookCount'] = undefined;

/**
 * @member {Number} bookListId
 */
CustomerShoppingCartBookListDto.prototype['bookListId'] = undefined;

/**
 * @member {Array.<module:model/CustomerShoppingCartBookListBookDto>} books
 */
CustomerShoppingCartBookListDto.prototype['books'] = undefined;

/**
 * @member {Array.<module:model/CustomerShoppingCartBookListBookCartDto>} cart
 */
CustomerShoppingCartBookListDto.prototype['cart'] = undefined;

/**
 * @member {String} description
 */
CustomerShoppingCartBookListDto.prototype['description'] = undefined;

/**
 * @member {Number} selectedBookCount
 */
CustomerShoppingCartBookListDto.prototype['selectedBookCount'] = undefined;

/**
 * @member {Number} selectedBookQuantityCount
 */
CustomerShoppingCartBookListDto.prototype['selectedBookQuantityCount'] = undefined;

/**
 * @member {String} title
 */
CustomerShoppingCartBookListDto.prototype['title'] = undefined;






export default CustomerShoppingCartBookListDto;

